import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ErrorResponse } from '@/common/types/errorResponse';
import { useMutation } from '@tanstack/react-query'
import { AxiosResponse } from 'axios';

interface UseReviewContactDocumentProps {
  contactId?: string
  publicCompanyLeadId?: string
  documentId?: string
  state?: string
  onSuccess: (response: AxiosResponse) => void
  onError: (error: ErrorResponse) => void
}

export const useReviewContactDocument = ({
  contactId,
  publicCompanyLeadId,
  documentId,
  state,
  onSuccess,
  onError,
}: UseReviewContactDocumentProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['reviewContactDocument'],
    mutationFn: (data?: { description?: string }) => {
      const lead = {
        contacts_attributes: [
          {
            id: contactId,
            documents_attributes: [
              {
                id: documentId,
                last_review_attributes: {
                  state,
                  description: data?.description,
                },
              },
            ],
          },
        ],
      }

      return privateAxios.putForm(`/funnel/public/leads/${publicCompanyLeadId}`, {
        lead,
      })
    },
    onSuccess,
    onError,
  })
}
